import * as Yup from 'yup';
import { Button, FieldGroup, Input, Spacer, Title } from 'internalLibrary';
import { FC, useMemo } from 'react';
import { PasswordRecoveryFormValues } from '../../../../types/ui';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import domainConfig from 'config/domain';
import styles from './PasswordRecovery.module.scss';

const initialValues: PasswordRecoveryFormValues = {
  email: '',
};

interface PasswordRecoveryFormProps {
  onSubmit: (values: PasswordRecoveryFormValues) => void;
  isLoading: boolean;
}

const PasswordRecoveryForm: FC<PasswordRecoveryFormProps> = (props) => {
  const { onSubmit, isLoading } = props;
  const { t } = useTranslation();
  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        email: Yup.string()
          .trim()
          .matches(domainConfig.emailRegExp, t('wrongFormat_email'))
          .required(t('requiredField')),
      }),
    [t],
  );

  const { handleSubmit, handleChange, handleBlur, values, touched, errors } =
    useFormik({
      validationSchema,
      initialValues,
      onSubmit,
    });

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <Title
        text={t('passwordRecovery_title')}
        className={styles.title}
        forceColumn
      />
      <Spacer marginBottom="15px" />
      <h5>{t('passwordRecovery_emailTitle')}</h5>
      <FieldGroup validationText={touched.email ? errors.email : ''}>
        <Input
          label={t('emailAddress')}
          name="email"
          touched={touched.email}
          onChange={handleChange}
          error={touched.email && Boolean(errors.email)}
          onBlur={handleBlur}
          value={values.email}
        />
      </FieldGroup>
      <Spacer marginTop="36px" marginBottom="26px">
        <Button
          className={styles.submit}
          disabled={isLoading}
          type="submit"
          fill={true}
        >
          {t('continue')}
        </Button>
      </Spacer>
    </form>
  );
};

export default PasswordRecoveryForm;
